export default {"src":"/_next/static/media/WhoWeAre_011A.f21fe209.JPG","height":690,"width":1920};